export function formatDateTime(dateString: string | Date | null | undefined): string {
  if (!dateString || dateString === 'null' || dateString === 'undefined' || dateString === '') {
    return 'Nunca';
  }

  try {
    const date = typeof dateString === 'string' ? new Date(dateString) : dateString;

    if (isNaN(date.getTime())) {
      return 'Nunca';
    }

    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).format(date);
  } catch {
    return 'Nunca';
  }
}

export function formatDate(dateString: string | Date | null | undefined): string {
  if (!dateString || dateString === 'null' || dateString === 'undefined' || dateString === '') {
    return 'Não informado';
  }

  try {
    const date = typeof dateString === 'string' ? new Date(dateString) : dateString;

    if (isNaN(date.getTime())) {
      return 'Não informado';
    }

    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(date);
  } catch {
    return 'Não informado';
  }
}

export function formatRelativeTime(dateString: string | Date | null | undefined): string {
  if (!dateString || dateString === 'null' || dateString === 'undefined' || dateString === '') {
    return 'Nunca';
  }

  try {
    const date = typeof dateString === 'string' ? new Date(dateString) : dateString;

    if (isNaN(date.getTime())) {
      return 'Nunca';
    }

    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Agora mesmo';
    if (diffMins < 60) return `Há ${diffMins} minuto${diffMins > 1 ? 's' : ''}`;
    if (diffHours < 24) return `Há ${diffHours} hora${diffHours > 1 ? 's' : ''}`;
    if (diffDays < 7) return `Há ${diffDays} dia${diffDays > 1 ? 's' : ''}`;

    return formatDateTime(date);
  } catch {
    return 'Nunca';
  }
}

export function formatPhoneNumber(phone: string | null | undefined): string {
  if (!phone) return 'Não informado';

  const cleaned = phone.replace(/\D/g, '');

  if (cleaned.length === 11) {
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(7)}`;
  }

  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 6)}-${cleaned.slice(6)}`;
  }

  if (cleaned.length === 13 && cleaned.startsWith('55')) {
    return `+55 (${cleaned.slice(2, 4)}) ${cleaned.slice(4, 9)}-${cleaned.slice(9)}`;
  }

  return phone;
}

export function formatNumber(value: number | null | undefined, decimals = 0): string {
  if (value === null || value === undefined) return '0';

  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}

export function formatCurrency(value: number | null | undefined): string {
  if (value === null || value === undefined) return 'R$ 0,00';

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
}

export function formatChartDate(
  dateString: string,
  period: '24h' | 'yesterday' | '7d' | '30d' | '3m'
): string {
  if (!dateString) return '';

  try {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      return dateString;
    }

    switch (period) {
      case '24h':
      case 'yesterday':
        return new Intl.DateTimeFormat('pt-BR', {
          hour: '2-digit',
          minute: '2-digit',
        }).format(date);

      case '7d':
      case '30d':
        return new Intl.DateTimeFormat('pt-BR', {
          day: '2-digit',
          month: 'short',
        }).format(date);

      case '3m':
        return new Intl.DateTimeFormat('pt-BR', {
          month: 'short',
          year: 'numeric',
        }).format(date);

      default:
        return dateString;
    }
  } catch {
    return dateString;
  }
}
